import { Injectable } from '@angular/core';
import { Regex } from '../constants/Regex';

@Injectable()
export class RegexService {

    public ValidateEmail(email: string) {
        var regexControl = new RegExp(Regex.PT_EMAIL_PATTERN);
        return regexControl.test(email);
    }

}